<template>
	<div>
		<div class="wrapper" :style="'width:'+width+'px'">

			<div v-for="(item,index) in baseData.list2">
				<div v-if="item.detail.type==0" class="hot-style">
					<img :src="item.detail.imageUrl0" />
					<a v-for="(subItem,index) in item.hotData" :href="subItem.link" :style="setStyle(subItem,item.detail.per)">
					</a>

				</div>
				<div v-if="item.detail.type==3" class="form-contain">
					<img :src="item.detail.imageUrl0" />
					<div class="form" :style="'top:'+item.detail.position+'%'">
						<input v-model="tel" placeholder="请输入手机号" type="number" pattern="[0-9]*" oninput="if(value.length>11){value=value.slice(0,11)}" />
						<div class="btn" @click="geCode"><img :src="item.detail.imageUrl1" /></div>
					</div>

				</div>
				<div v-if="item.detail.type==2" style="position: relative;">
					<img :src="item.detail.imageUrl0" />
					<div class="vedio">
						<iframe class="video_iframe" id="myFrame" frameborder="0" :src="'https://v.qq.com/iframe/player.html?vid='+item.detail.link+'&tiny=0&auto=0'" allowfullscreen></iframe>

					</div>

				</div>
			</div>
		</div>
		<div class="mask-tips" v-if="showTips">
			<div class="mask-content">
				<p class="close">
					<a href="#" @click="showTips=false"></a>
				</p>
				<h2 class="title">恭喜您！</h2>
				<p class="tips">{{tips}}</p>
			</div>
		</div>
	</div>

</template>
<script>
	import '../../util/setDplus.js';
	import '../../util/sha1.js';
	import '../../util/common.js';
	import QRCode from 'qrcode'
	export default {
		name: 'demo',
		components: {
			QRCode: QRCode
		},
		data() {
			return {
				tel: '',
				tips: '',
				width: '',
				showDetail: false,
				showTips: false,
				companyName: '',
				companyId: '',
				baseData: {},
				cityData: {
					"19": 'guangdong',
					"32": 'guangdong',
					"33": 'guangdong',
					"34": 'guangdong',
					"1": 'beijing',
					"2": 'beijing',
					"3": 'beijing',
					"9": 'huadong',
					"11": 'huadong',
					"27": 'chongqing',
					"23": 'shanxi',
					"6": 'liaoning',
					"7": 'jilin',
					"8": 'heilongjiang',
					"10": 'jiangsu',
					"12": 'anhui',
					"13": 'fujian',
					"14": 'jiangxi',
					"15": 'shandong',
					"16": 'zhongyuan',
					"17": 'hubei',
					"18": 'hunan',
					"20": 'hainan',
					"28": 'sichuan',
					"31": 'sichuan',
					"29": 'guizhou',
					"30": 'yunnan',
					"4": 'shanxi1',
					"22": 'gansu',
					"25": 'gansu',
					"26": 'gansu',
					"5": 'neimenggu',
					"21": 'guangxi',
					"24": 'xinjiang',
				}
			}
		},
		methods: {
			judgeNull(str) {
				if(typeof(str) == "undefined" || "" + str == "undefined" || str == null) {
					return false;
				} else {
					return true
				}
			},
			setStyle(item, per) {
				var str1 = item.x * 1 / this.baseData.width * 100 + "%";
				var str = "left:" + item.x * 1 / this.baseData.width * 100 + "%;width:" + item.w * 1 / this.baseData.width * 100 + "%;height:" + item.h * 1 / (this.baseData.width / per) * 100 + "%;top:" + item.y * 1 / (this.baseData.width / per) * 100 + "%";
				console.log(str)
				return str

			},
			geCode() {
				if(this.tel.length != 11) {
					this.$message({
						message: "请输入正确的手机号码！",
						type: 'warning'
					});

				} else {
					var param = {
						phone: this.tel,
						sessionId: 'random',
						fromSource: this.$route.query.channel
					}
					this.Post("rest/coupon/get7Coupon", param).then((data) => {
						if(data.result) {
							this.tips = data.objValue;
							this.showTips = true;
						} else {
							this.$message({
								message: data.value,
								type: 'warning'
							});
						}

					})

				}
			},
			createNonceStr() {
				var str = ''
				var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
				for(var i = 0; i < 16; i++) {
					str += chars[Math.floor(Math.random() * chars.length)]
				}
				this.createNonceStr = str;
			},
			createTimeStamp() {
				var str = new Date().getTime().toString();
				str = str.slice(0, 10);
				this.createTimeStamp = str;
			},
			getTicket() {
				this.Get('/wechatPage/Wx/getJsapiTicket').then((data) => {
					if(data.result) {
						this.wx_ticket = data.objValue;
						this.shareSetting();
					}
				})

			},
			shareSetting() {
				console.log(1)
				var jsapi_ticket = "jsapi_ticket=" + this.wx_ticket + "&noncestr=" + this.createNonceStr + "&timestamp=" + this.createTimeStamp + "&url=" + window.location.href;
				var that = this;
				var signature = SHA2(jsapi_ticket);

				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: "wx91e6d2300bb98ec4", // 必填，公众号的唯一标识
					timestamp: this.createTimeStamp, // 必填，生成签名的时间戳
					nonceStr: this.createNonceStr, // 必填，生成签名的随机串
					signature: signature, // 必填，签名
					jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', ] // 必填，需要使用的JS接口列表
				});
				//分享给朋友
				wx.ready(function() { //需在用户可能点击分享按钮前就先调用
					wx.onMenuShareTimeline({
						title: that.baseData.title, // 分享标题
						desc: that.baseData.desc, // 分享描述
						link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: that.baseData.imageUrl, // 分享图标
						success: function() {

						}
					});
				});

				wx.ready(function() { //需在用户可能点击分享按钮前就先调用
					wx.onMenuShareAppMessage({
						title: that.baseData.title, // 分享标题
						desc: that.baseData.desc, // 分享描述
						link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: that.baseData.imageUrl, // 分享图标
						success: function() {

						}
					});
				});
			},

			initData(id) {
				const that = this;

				this.Post("/rest/company/queryDefaultCompany").then((data) => {

					if(data.result) {
						setTimeout(() => {
							this.getTicket();
							var baseData = getData();
							if(that.$route.query.ipFrom) {
								that.baseData = baseData[that.$route.query.ipFrom];
							} else {
								that.baseData = baseData[that.cityData[data.objValue.district]];
							}

							if(!that.judgeNull(that.baseData)) {
								that.baseData = baseData["template"];
							}
							this.companyId = data.objValue.district;
							if(data.objValue.district == '19' || data.objValue.district == '32' || data.objValue.district == '34' || data.objValue.district == '33') {
								this.companyId = '19'
								this.companyName = 'guangdong'
							} else if(data.objValue.district == '1' || data.objValue.district == '2' || data.objValue.district == '3') {
								this.companyName = 'beijing'
							} else if(data.objValue.district == '9' || data.objValue.district == '11') {
								this.companyName = 'huadong'
							} else if(data.objValue.district == '28' || data.objValue.district == '31') {
								this.companyId = '28'
								this.companyName = "sichuang"
							} else if(data.objValue.district == '22' || data.objValue.district == '25' || data.objValue.district == '26') {
								this.companyId = '22'
								this.companyName = "gansu"
							} else {
								this.companyId = data.objValue.district;
								this.companyName = that.cityData[data.objValue.district]
							}
							document.title = that.baseData.title;
							dplus.track("七大网页面_" + this.$route.query.jsUrl, {
								"七大网来源": this.$route.query.channel ? this.$route.query.channel : "700",
								"地区公司": this.companyName,
								"批次号": this.$route.query.jsUrl
							});

							if(!!this.$route.query.channel) {
								const param = {
									"fromSource": this.$route.query.channel,
									"path": this.companyName
								}
								this.Post("/rest/log/addLog", param).then((data) => {

								})

							}

							//							this.width = document.documentElement.clientWidth;
							if(document.documentElement.clientWidth < 600) {
								this.width = '100%'
							} else {

								this.width = this.baseData.width;
								this.showCode = true;
							}

						}, 200)

					} else {
						this.$message({
							message: data.value,
							type: 'warning',
						});
					}
				})
			},
		},
		beforeCreate() {
			if(this.$route.query.jsUrl) {
				const url = this.$route.query.jsUrl
				
				const s1 = document.createElement('script');
				s1.type = 'text/javascript';
				s1.src = "https://appd.evergrande.com/makePost/js/" + url + ".js";
				document.body.appendChild(s1);
				const s = document.createElement('script');
				s.type = 'text/javascript';
				s.src = "https://files.evergrande.com/advertisement/js/" + url + ".js";
				document.body.appendChild(s);
			}
			const s = document.createElement('script');
			s.type = 'text/javascript';
			s.src = "https://res.wx.qq.com/open/js/jweixin-1.2.0.js";
			document.body.appendChild(s);

		},
		mounted() {
			if(this.$route.query.jsUrl) {
				const url = this.$route.query.jsUrl			
				const s1 = document.createElement('script');
				s1.type = 'text/javascript';
				s1.src = "https://appd.evergrande.com/makePost/js/" + url + ".js";
				document.body.appendChild(s1);
				const s = document.createElement('script');
				s.type = 'text/javascript';
				s.src = "https://files.evergrande.com/advertisement/js/" + url + ".js";
				document.body.appendChild(s);
			}
			this.createNonceStr();
			this.createTimeStamp();
			setTimeout(() => {
				this.initData();
			}, 1000)
		}
	}
</script>
<style scoped lang="less">
	.wrapper {
		margin: 0 auto;
		img {
			width: 100%;
			display: block;
		}
		.hot-style {
			position: relative;
			a {
				position: absolute;
			}
		}
		.text-detail {
			text-align: right;
			position: absolute;
			left: -242px;
			color: #ce000a;
			top: 40px;
			width: 218px;
			display: inline-block;
			height: 100px;
			overflow-wrap: break-word;
		}
		.show-detail {
			background: #ce000a;
			opacity: 0.6;
		}
		#myFrame {
			display: block;
			z-index: 1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 92.8%;
		}
		.vedio {
			position: absolute;
			top: 4%;
			left: 7.5%;
			width: 85%;
			height: 0;
			padding-bottom: 52%;
		}
		.form-contain {
			position: relative;
			width: 100%;
			img {
				width: 100%
			}
			.form {
				position: absolute;
				left: 5%;
				height: 100%;
				width: 90%;
				display: flex;
				justify-content: space-around;
				align-items: center;
				input {
					height: 32px;
					width: 12.8rem;
					padding-left: 0.4rem;
				}
				.btn {
					width: 6rem;
					min-height: 2rem;
					cursor: pointer;
					font-size: 4rem;
				}
			}
		}
	}
	
	.mask-tips {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.6);
		top: 0;
		left: 0;
		z-index: 999;
		.mask-content {
			width: 66%;
			background: #f5f5f5;
			position: absolute;
			top: 18%;
			left: 50%;
			margin-left: -33%;
			font-size: 1rem;
			text-align: center;
			border-radius: 12px;
			p.close {
				position: absolute;
				cursor: pointer;
				width: 100%;
				/* padding-top: 5px; */
				padding-right: 10px;
				a {
					cursor: pointer;
					position: absolute;
					display: inline-block;
					right: 0.8rem;
					top: -0.6rem;
					width: 16px;
					height: 16px;
					background: url(../../assets/close.jpg) no-repeat;
					background-size: contain;
				}
			}
			.title {
				text-align: center;
				height: 2rem;
				line-height: 2rem;
				font-weight: bold;
				color: #fff;
				font-size: 1rem;
				border-top-left-radius: 12px;
				border-top-right-radius: 12px;
				background: rgb(241, 155, 56);
				margin: 0
			}
			.tips {
				text-align: center;
				font-weight: bold;
				color: #000;
				font-size: 0.8rem;
				padding: 0.1rem 0 0.2rem 0.1rem;
			}
		}
	}
	
	#code {
		position: fixed;
		right: 40px;
		bottom: 100px;
		z-index: 90;
	}
	
	.show-detail {
		color: #fff;
		text-align: center;
		height: 32px;
		line-height: 32px;
		background: #ce000a;
		width: 196px;
		position: fixed;
		right: 40px;
		bottom: 60px;
		cursor: pointer;
	}
	
	.showHot {
		background: #ce000a;
		opacity: 0.6;
	}
	
	.detail-style {
		border-top: 1px solid #d9d9d9;
		z-index: 90;
	}
</style>


// WEBPACK FOOTER //
// src/views/MakePost/Page.vue